var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature"},[_c('div',{staticClass:"item"},[_c('q-icon',{staticClass:"q-mb-sm",attrs:{"color":"primary","name":_vm.iconName,"size":"59px"}}),_c('div',{directives:[{name:"t",rawName:"v-t",value:(_vm.text),expression:"text"}],staticClass:"feature__text"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }